import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'

import idLocale from './id'
import enLocale from './en'
import zhLocale from './zh'
import en from 'vant/lib/locale/lang/en-US'
import id from 'vant/lib/locale/lang/en-US'
import zhCN from 'vant/lib/locale/lang/zh-CN'

Vue.use(VueI18n)
var smarttranslang = localStorage.getItem('smarttranslang')
const messages = {
  en: {
    // ...enLocale,
    ...en
  },
  zh: {
    // ...zhLocale,
    ...zhCN
  },
  id: {
    // ...idLocale,
    ...id
  }
}

export function getLanguage() {
  const chooseLanguage = Cookies.get('language')
  if (chooseLanguage) return chooseLanguage

  // if has not choose language
  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'en'
}

const i18n = new VueI18n({
  locale: getLanguage(),
  messages
})
i18n.mergeLocaleMessage(Cookies.get("language"), JSON.parse(smarttranslang))

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js